<template>
  <div>
    <router-view></router-view>
    <van-tabbar fixed v-model="active">
      <van-tabbar-item :to="userRole === 'parents' ? '/home' : '/thome'" icon="wap-home-o">首页</van-tabbar-item>
      <van-tabbar-item v-show="userRole == 'teacher'" to="/book" icon="apps-o">通讯录</van-tabbar-item>
      <van-tabbar-item to="/user" icon="contact-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { getOpenid } from '@/api/home.js'
import { getInfo } from '@/utils/storage'
import { Toast } from 'vant'
export default {
  name: 'LayoutIndex',
  data() {
    return {
      active: 0,
      userRole: ''
    }
  },
  mounted() {
    this.getOpenid()
    const isLogin = this.$store.getters.token
    console.log('isLogin', isLogin)
    if (!isLogin) {
      this.$router.push('/login')
      return
    }
    //获取用户角色
    const userInfo = getInfo()
    console.log('userInfo', userInfo)
    this.userRole = userInfo.identify
    console.log('userRole', this.userRole)
    // 获取url上的路由
    const currentRoute = this.$route.path
    console.log('currentRoute', currentRoute)
    switch (currentRoute) {
      case '/home':
        this.active = 0
        break
      case '/thome':
        this.active = 0
        break
      case '/book':
        this.active = 1
        break
      case '/user':
        this.active = 2
        break
      default:
        this.active = 0
    }
  },
  created() {

  },
  methods: {
    async getOpenid() {
      console.log('mounted', localStorage.getItem('openid'));
      // localStorage.setItem('openid', 'oge3z19DbOVFURWflLNz4PsshS6Q');
      // if (!localStorage.getItem('openid') || localStorage.getItem('openid') == undefined) {
        //判断url中有没有code
        // 1. 获取 # 前面的查询字符串（即 "?code=xxx&state=1"）
        const search = window.location.search;
        // 2. 解析查询字符串
        const params = new URLSearchParams(search);
        // 3. 获取 code 参数
        const code = params.get('code');
        console.log('code', code);
        if (code) {
          //根据code获取openid
          let res = await getOpenid(code)
          if (res.code == 10000) {
            localStorage.setItem('openid', res.data);
            window.location.href = 'https://siyuan.renlianiot.com';
          }else{
            Toast.fail('微信授权失败')
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx36b554368520bbde&redirect_uri=https://siyuan.renlianiot.com&response_type=code&scope=snsapi_base&state=1&connect_redirect=1#wechat_redirect'
          }
        }
      // }
    }

  }
}
</script>

<style></style>
